/* ============================================================
   Choco Crystal — product-form.js
   Variant selection (price/availability) + product gallery.
   Re-initialises on shopify:section:load for the theme editor.
   ============================================================ */
(function () {
  'use strict';

  function initProductForm(scope) {
    var root = scope || document;
    root.querySelectorAll('[data-product-form]').forEach(function (form) {
      if (form.dataset.ccBound) return;
      form.dataset.ccBound = '1';

      var variantsData = form.querySelector('[data-variants-json]');
      var variants = [];
      try { variants = JSON.parse(variantsData ? variantsData.textContent : '[]'); } catch (e) {}
      var idInput = form.querySelector('[data-variant-id]');
      var selects = Array.prototype.slice.call(form.querySelectorAll('[data-variant-option]'));
      var priceTarget = document.querySelector('[data-product-price]');
      var submitBtn = form.querySelector('[type="submit"]');

      function currentOptions() { return selects.map(function (s) { return s.value; }); }

      function findVariant(opts) {
        return variants.find(function (v) {
          return v.options.every(function (o, i) { return o === opts[i]; });
        });
      }

      function update() {
        if (!variants.length) return;
        var variant = selects.length ? findVariant(currentOptions()) : variants[0];
        if (!variant) {
          if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = submitBtn.getAttribute('data-unavailable') || 'Niedostępny'; }
          return;
        }
        if (idInput) idInput.value = variant.id;
        if (priceTarget && variant.price_html) priceTarget.innerHTML = variant.price_html;
        if (submitBtn) {
          submitBtn.disabled = !variant.available;
          submitBtn.textContent = variant.available
            ? (submitBtn.getAttribute('data-add-label') || 'Dodaj do koszyka')
            : (submitBtn.getAttribute('data-soldout-label') || 'Wyprzedane');
        }
        // update URL param without reload
        if (history.replaceState && variant.id) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          history.replaceState({}, '', url.toString());
        }
      }

      selects.forEach(function (s) { s.addEventListener('change', update); });
      update();
    });
  }

  function initGallery(scope) {
    var root = scope || document;
    root.querySelectorAll('[data-gallery]').forEach(function (gallery) {
      if (gallery.dataset.ccBound) return;
      gallery.dataset.ccBound = '1';
      var main = gallery.querySelector('[data-gallery-main] img');
      gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var full = thumb.getAttribute('data-full');
          var alt = thumb.getAttribute('data-alt') || '';
          if (main && full) { main.src = full; main.alt = alt; }
          gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
          thumb.classList.add('is-active');
        });
      });
    });
  }

  function initAll(scope) { initProductForm(scope); initGallery(scope); }

  document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  document.addEventListener('cc:reinit', function (e) { initAll(e.detail && e.detail.target ? e.detail.target : document); });
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
